import React, { useState, useEffect } from "react";
import { Card, Button } from 'antd';
import ReactEcharts from 'echarts-for-react';
import { YhBox } from "@/components/YhBox";

import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import { homeService } from "./homeService"
import { formatNum } from "../../utils/utils";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export function Bar() {

    const [EchartsWeek, setEchartsWeek] = useState([])
    const [EchartsArr, setEchartsArr] = useState([])
    const [echartsInfo, setEchartsInfo] = useState([]);
    let LanguageArr = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, language } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    useEffect(() => {
        homeService.zhou().then(res => {
            let { retData } = res
            filter(retData)
        })
    }, [language])

    const nameObj = {
        "salesAmountDay": "销售额",
        "maintenanceAmountDay": "维修额",
        "warehousingAmountDay": "入库额",
        "deliveryAmountDay": "出库额",//deliveryAmountDay
        "tru": "营业额"
    }
    const nameObjEn = {
        "salesAmountDay": "salesAmount",
        "maintenanceAmountDay": "maintenanceAmount",
        "warehousingAmountDay": "warehousingAmount",
        "deliveryAmountDay": "deliveryAmount",
        "tru": "turnover"
    }
    //

    const filter = (res) => {
        let arrInfo = [];
        let resObj = res[0]
        let resTime = resObj.deliveryAmountDay.map(item => item.day)
        setEchartsWeek(resTime)
        // resObj
        let newResObj = Object.keys(resObj).map((item) => {
            let obj = {};
            let newData = resObj[item].map(item2 => {
                obj[item2.day] = {
                    num: item2.num,
                    amount: item2.amount
                }
                return `${item2.num}`
            })
            arrInfo.push(obj);
            return {
                name: language == "zh-CN" ?nameObj[item]:nameObjEn[item],
                type: "bar",
                data: newData
                // data: resObj[item].map(item2 => { return { num: item2.num, amount: item2.amount } }),
                // amount: resObj[item].map(item2 => { return item2.amount })

            }

        })
        // let newLineObj = Object.keys(resObj).map((item) => {
        //     return item = {
        //         name: nameObj[item]+"度",
        //         type: "line",
        //         data: resObj[item].map(item2 => { return `${item2.amount}` })
        //     }
        // })
        setEchartsInfo(arrInfo);
        setEchartsArr([...newResObj])
    }

    const option = {
        // color: ["#76B0FF","#FD8B8D", "#A776FD", "#FDD175"],
        // color: ["#A776FD", "#FDD175", "#76B0FF", "#FD8B8D","#87e8de"],
        // color: ["#87e8de", "#A776FD", "#FD8B8D", "#76B0FF","#FDD175"],
        //提示
        tooltip: {
            trigger: 'axis',
            // axisPointer: {
            //     type: 'cross'
            // },
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            formatter: function (params) {
                let str = "";
                if (params && params.length > 0) {
                    params.forEach(item => {
                        const { seriesName, value, seriesIndex, name } = item;
                        // console.log(seriesName, value, seriesIndex, name)
                        str += `<span style="font-size:10px">${item.seriesName}</span><br/><span style="font-size:10px">数量:${item.data}</span><span style="font-size:10px">&nbsp;&nbsp;金额:￥${formatNum(echartsInfo?.[seriesIndex]?.[name]?.["amount"])}</span><br/>`
                    })
                }
                return str;
            },
            // position: function (pos, params, el, elRect, size) {
            //     var obj = { top: 10 };
            //     obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            //     return obj;
            // },
            extraCssText: 'width: 170px'
        },
        //图列
        legend: {
            show: true,
            orient: 'horizontal',
            x: "left",
            y: "10",
            left:50,
            top:"-4",
            itemWidth: 16,
            itemHeight: 10,
            icon: "roundRect",
            borderRadius: 10,
            // data: ['预约量', '进厂量', '失约量', '回访量','销售量']
            // data: ['销售额', '营业额', '维修额', '应收金额', '实收金额']

        },
        //画布
        grid: {
            left: '5%',
            right: '5%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            // data: ['4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月']
            data: EchartsWeek

        },
        yAxis: {
            type: 'value',
            // name:"营业额（万）"
        },
        label: {
            show: false
        },
        itemStyle: {
            barBorderRadius: [2, 2, 0, 0] //（顺时针左上，右上，右下，左下）
        },
        series: EchartsArr
        // series: [
        //     {
        //         name: '销售额',
        //         type: 'bar',
        //         data: [320, 332, 301, 334, 390, 182, 191, 234]
        //     },
        //     {
        //         name: '营业额',
        //         type: 'bar',
        //         data: [220, 182, 191, 234, 290, 232, 201, 154]
        //     },
        //     {
        //         name: '维修额',
        //         type: 'bar',
        //         data: [150, 232, 201, 154, 190, 77, 101, 99]
        //     },
        //     {
        //         name: '应收金额',
        //         type: 'bar',
        //         data: [98, 77, 101, 99, 40, 332, 301, 334]
        //     }
        // ]
    };
    const onYer = () => {
        homeService.yer().then(res => {
            let { retData } = res
            filter(retData)
        })
    }
    const onZhou = () => {
        homeService.zhou().then(res => {
            let { retData } = res
            filter(retData)
        })
    }
    const rightChildren = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onZhou}
        >{Locale["week"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onYer}
        >{Locale["month"]}</Button></>
    return (
        <YhBox
            title={<></>}
            style={{ height: "calc(50% - 15px)" }}
            rightChildren={rightChildren}
        >
            <div style={{ marginTop: "-25px" }}>
                <ReactEchartsCore
                    echarts={echarts}
                    theme="light"
                    option={option}
                    // style={{ height: '100%' }}
                />
            </div>
        </YhBox>
    )
}